module.exports = __webpack_public_path__ + "static/media/11.63df5ec1.jpg";